import React, { useEffect } from 'react';
import './Css/Competences.css';
import { FaReact, FaHtml5, FaCss3, FaJs, FaFigma, FaDocker, FaGithub, FaJira, FaSymfony, FaLock, FaDesktop, FaNetworkWired, FaTerminal,FaCloud } from 'react-icons/fa';
import { SiPostman, SiPhpmyadmin } from "react-icons/si";
import { BsFiletypeSql } from "react-icons/bs";
import { SiGitlab } from 'react-icons/si';


const Competences = () => {

  useEffect(() => {
    const sections = document.querySelectorAll('.cv-section, .cv-skills li');
    
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
        }
      });
    }, {
      threshold: 0.1
    });

    sections.forEach(section => {
      observer.observe(section);
    });

    return () => {
      sections.forEach(section => {
        observer.unobserve(section);
      });
    };
  }, []);

  return (
    <div className="competences-container">
      <section className="cv-section">
        <h2>Compétences Back</h2>
        <ul className="cv-skills">
        <li><FaSymfony /> Symfony</li>
<li><BsFiletypeSql /> SQL / <SiPhpmyadmin /> PhpMyAdmin</li>
<li><FaNetworkWired /> API REST</li>
<li><FaLock /> Sécurité des applications web </li>
<li><FaDesktop /> Doctrine ORM</li>
<li>Gestion des erreurs & logs</li>

        </ul>
      </section>

      <section className="cv-section">
        <h2>Compétences Front</h2>
        <ul className="cv-skills">
          <li><FaJs /> JavaScript</li>
          <li><FaHtml5 /> HTML</li>
          <li>📱 Responsive Design</li>
          <li><FaCss3 /> CSS</li>
          <li><FaReact /> React</li>
          <li><FaReact /> React Router</li>

        </ul>
      </section>
      <section className="cv-section">
        <h2>Compétences Réseaux Cybersécurité </h2>
        <ul className="cv-skills">
          <li><FaDesktop /> Virtualisation</li>
          <li><FaNetworkWired /> TCP / IP</li>
          <li><FaTerminal /> Kali Linux</li>
          <li><FaLock /> VPN</li>
          <li><FaCloud /> Cloud</li>
        </ul>
      </section>
      <section className="cv-section">
        <h2>Outils de développement</h2>
        <ul className="cv-skills">
  <li><FaGithub /> GitHub</li>
  <li><SiGitlab /> GitLab</li>
  <li><FaDocker /> Docker</li>
  <li><SiPostman /> Postman</li>
</ul>
        <br />
        <h2>Outils de gestion de projet</h2>
        <ul className="cv-skills">
          <li><FaJira /> Jira</li>
        </ul>
      </section>
    </div>
  );
};

export default Competences;
